import { queryOptions } from '@tanstack/react-query';
import {
  changeRequestApi,
  type ChangeRequestFilters,
  type ChangeRequestPageParams,
} from './change-request-api';

/**
 * Query keys for the moderation queue.
 *
 * No branch in the key: the queue is merchant-scoped through the JWT claim
 * (`change-requests/by-merchant`), so switching branches does not change it.
 */
export const changeRequestKeys = {
  all: ['change-requests'] as const,
  /**
   * Every listing, whatever its filter or page — the invalidation prefix. A
   * submit or a cancel changes what several pages hold, so mutations
   * invalidate this rather than the on-screen entry alone.
   */
  lists: () => [...changeRequestKeys.all, 'list'] as const,
  /** One page under one filter. Both are in the key because both narrow the
   * REQUEST — keying without them would serve a filtered page as the whole
   * queue. */
  list: (filters: ChangeRequestFilters, page: ChangeRequestPageParams) =>
    [...changeRequestKeys.lists(), { status: filters.status }, page] as const,
};

export const changeRequestQueries = {
  list: (filters: ChangeRequestFilters, page: ChangeRequestPageParams) =>
    queryOptions({
      queryKey: changeRequestKeys.list(filters, page),
      queryFn: () => changeRequestApi.list(filters, page),
      // Paging and switching tabs both walk to a fresh key. Keeping the last
      // answer on screen means the table re-fills in place instead of
      // collapsing to a skeleton and back on every step.
      placeholderData: (previous) => previous,
    }),
};
